import { useEffect, useRef, useState } from "react";
import { GrFormRefresh } from "react-icons/gr";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addAndUpload,
  deleteDocumentList,
  getDocumentByMultipleOpeAndRef,
  getDocumentByOpeAndRef,
  updateAndUpload,
} from "../../../api/documentUpload";
import { getBulkDropdownData } from "../../../api/keyvalue";
import {
  addRequestInitiation,
  fetchDataById,
  fetchInsIdsByJobId,
  fetchJobConfirmationAlerts,
  fetchJobIdsByRequestId,
  updateRequestInitiation,
} from "../../../api/requestCreation";
import { consignmentsByCustomer } from "../../../api/stkConsignmentTypeApi";
import { FORMS, MODULES } from "../../../const";
import { formatFromJsonDate, isBeforeJson } from "../../../dateConfig";
import useFirstAndLastAuthorizedTab from "../../../hooks/useFirstAndLastAuthorizedTab";
import useNextAndPreviousAuthority from "../../../hooks/useNextAndPreviousAuthority";
import useUserCompany from "../../../hooks/useUserCompany";
import store from "../../../store";
import { errorActions } from "../../../store/error-slice";
import { requestActions } from "../../../store/request-slice";
import DocumentUpload from "../../DocumentUpload";
import Button from "../../input/Button";
import Modal from "../../Modal";
import {
  schedulerMonthlyValidation,
  schedulerOneDayValidation,
  schedulerValidation,
} from "../../validations/RequestSchedulerCreation";
import {
  validateQuickRequestInitiation,
  validateQuickRequestLocation,
  validateQuickRequestTransport,
} from "../../validations/ValidateQuickRequestCreation";
import JobConfirmationAlert from "../RequestCreation/JobConfirmationAlert";
import QuickLocationConsigneeItem from "./QuickLocationConsigneeItem/QuickLocationConsigneeItem";
import QuickRequestInitiation from "./QuickRequestInitiation";
import QuickRequestOtherInfo from "./QuickRequestOtherInfo";
import QuickRequestSummary from "./QuickRequestSummary";
import QuickRequestTransport from "./QuickRequestTransport";

const QuickRequestRefactor = ({
  id,
  viewOnlyMode = false,
  cleanUp = false,
  cleanUpFunction = () => {},
  context,
  jobId,
}) => {
  const requestInitRef = useRef();
  const requestTransportRef = useRef();
  const requestSummaryRef = useRef();
  const requestOtherRef = useRef();
  const modalRef = useRef();
  const docRef = useRef();

  const { firstViableTab, lastViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Transaction,
    section: FORMS.REQUEST,
  });

  const [nextValidated, setNextValidated] = useState(null);
  const [step, setStep] = useState(firstViableTab);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchLoading, setIsFetchLoading] = useState(false);
  const [departmentTypeOptions, setDepartmentTypeOptions] = useState([]);
  const [shipmentTypeOptions, setShipmentTypeOptions] = useState([]);
  const [shipmentCategoryOptions, setShipmentCategoryOptions] = useState([]);
  const [yesNoOptions, setYesNoOptions] = useState([]);
  const [itemTypeOptions, setItemTypeOptions] = useState([]);
  const customerId = useSelector((state) => state.request.reqLCustomerId);
  const [consignmentTypeOptions, setConsignmentTypeOptions] = useState([]);
  const [allConsignmentTypeOptions, setAllConsignmentTypeOptions] = useState([]);
  const [locationFlagOptions, setLocationFlagOptions] = useState([]);
  const [uomTypeOptions, setUomTypeOptions] = useState([]);
  const [timeUomOptions, setTimeUomOptions] = useState([]);
  const [chargeTypeOptions, setChargeTypeOptions] = useState([]);
  const [statusTypeOptions, setStatusTypeOptions] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);
  const [activeOptions, setActiveOptions] = useState([]);
  const [scheduleTypeOptions, setScheduleTypeOptions] = useState([]);
  const auth = useSelector(
    (state) => state.user.permissions[MODULES.Transaction],
  );
  const requestInitiationViewPermission =
    auth[FORMS.QUICK_REQUEST.CREATION_INFO.form]?.FORM?.VIEW;
  const requestTransportViewPermission =
    auth[FORMS.QUICK_REQUEST.TRANSPORT.form]?.FORM?.VIEW;
  const requestLocationViewPermission =
    auth[FORMS.QUICK_REQUEST.LOCATION.form]?.FORM?.VIEW;
  const requestConsigneeViewPermission =
    auth[FORMS.QUICK_REQUEST.CONSIGNEE.form]?.FORM?.VIEW;
  const requestSummaryViewPermission =
    auth[FORMS.QUICK_REQUEST.SUMMARY.form]?.FORM?.VIEW;
  const requestOtherInfoViewPermission =
    auth[FORMS.QUICK_REQUEST.OTHER.form]?.FORM?.VIEW;

  const hasLocErrors = useSelector((state) => state.request.hasLocErrors);
  const hasConErrors = useSelector((state) => state.request.hasConErrors);
  const submitted = useSelector((state) => state.request.submitted);

  const user = useSelector((state) => state.user);
  const userCompany = useUserCompany();
  const dispatch = useDispatch();
  const [hasRequestInitErrors, setHasRequestInitErrors] = useState(false);
  const [hasRequestTransportErrors, setHasRequestTransportErrors] =
    useState(false);
  const [hasRequestSummaryErrors, setHasRequestSummaryErrors] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isLocConItemLoading, setIsLocConItemLoading] = useState(false);
  const [isTransportLoading, setIsTransportLoading] = useState(false);
  const [isOtherInfoLoading, setIsOtherInfoLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentDocuments, setCurrentDocuments] = useState([]);
  const [docReference, setDocReference] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState([1, 2, 3]);
  const [insIds, setInsIds] = useState([]);

  const { next, prev } = useNextAndPreviousAuthority({
    sectionKey: "stakeholder",
    minTab: 1,
    maxTab: 6,
    module: MODULES.Transaction,
    section: FORMS.QUICK_REQUEST,
    currentTab: step,
    authenticated: true,
  });

  const [jobConfirmAlerts, setJobConfirmAlerts] = useState([]);
  const [needToOpenModal, setNeedToOpenModal] = useState(false);
  const modalRef2 = useRef();
  const navigate = useNavigate();
  // const customerId = useSelector((state) => state.request.reqLCustomerId);
  // const [jobConfirmAlertConfiguration, setJobConfirmAlertConfiguration] =
  //   useState(false);

  // useEffect(() => {
  //   (async () => {
  //     if (customerId) {
  //       const jobConfAlertConfig =
  //         await stakeholderConfigByStakeholderAndConfig(
  //           customerId,
  //           CONFIGS.JOB_CONFIRMATION_ALERT,
  //         );
  //       console.log("jobConfAlertConfig", jobConfAlertConfig);
  //       if (jobConfAlertConfig) {
  //         setJobConfirmAlertConfiguration(jobConfAlertConfig?.scnBoolean);
  //       }
  //     }
  //   })();
  // }, [customerId]);

  useEffect(() => {
    (async () => {
      const response = await fetchJobConfirmationAlerts();
      if (response.length > 0) {
        setJobConfirmAlerts(response);
        setNeedToOpenModal(true);
      }
    })();
  }, []);

  useEffect(() => {
    if (needToOpenModal) {
      modalRef2.current.showModal();
      toast.warn("Please confirm below jobs before creating request.", {
        autoClose: 20000,
        containerId: "Modal",
      });
    }
  }, [needToOpenModal]);

  const closeModal2 = (withNavigate = true) => {
    setNeedToOpenModal(false);
    modalRef2.current.close();
    if (withNavigate) {
      navigate("/");
    }
  };

  useEffect(() => {
    if (id) {
      (async () => {
        setIsFetchLoading(true);
        const response = await fetchDataById(id);
        setResponse(response);

        const jobIds = await fetchJobIdsByRequestId(id);
        setJobs(jobIds);
        const insIdSet = await fetchInsIdsByJobId(jobId);
        setInsIds(insIdSet);

        setEditMode(true);
      })();
    }
  }, [id, dispatch, viewOnlyMode]);

  console.log("jobs", jobs);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const {
        departments: departmentTypeData,
        shipment_type: shipmentTypeData,
        shipment_category: shipmentCategoryData,
        yesno: yesNoData,
        item_type: itemTypeData,
        consignment_type: consignmentTypeData,
        rlk_location: locationFlagData,
        uom: uomTypeData,
        "UOM#she_month": timeUomData,
        status: statusTypeData,
        chg_type: chargeTypeData,
        doc_type: docTypeData,
        "file_name#7": fileNameData,
        active: activeData,
        schedule_type: scheduleTypeData,
      } = await getBulkDropdownData([
        { key: "departments" },
        { key: "shipment_type" },
        { key: "shipment_category" },
        { key: "yesno" },
        { key: "item_type" },
        { key: "consignment_type" },
        { key: "rlk_location" },
        { key: "uom" },
        { key: "UOM", group: "she_month" },
        { key: "status" },
        { key: "chg_type" },
        { key: "doc_type" },
        { key: "file_name", group: "7" },
        { key: "active" },
        { key: "schedule_type" },
      ]);

      setDepartmentTypeOptions(departmentTypeData);
      setShipmentTypeOptions(shipmentTypeData);
      setShipmentCategoryOptions(shipmentCategoryData);
      setYesNoOptions(yesNoData);
      setItemTypeOptions(itemTypeData);
      setConsignmentTypeOptions(consignmentTypeData);
      setAllConsignmentTypeOptions(consignmentTypeData);
      setLocationFlagOptions(locationFlagData);
      setUomTypeOptions(uomTypeData);
      setTimeUomOptions(timeUomData);
      setStatusTypeOptions(statusTypeData);
      setChargeTypeOptions(chargeTypeData);
      setDocumentTypeOptions(docTypeData);
      setFileNameOptions(fileNameData);
      setActiveOptions(activeData);
      setScheduleTypeOptions(scheduleTypeData);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (customerId) {
        const data = await consignmentsByCustomer(customerId);
        if (data && data.length > 0) {
          setConsignmentTypeOptions(data);
        } else if (allConsignmentTypeOptions.length > 0) {
          setConsignmentTypeOptions(allConsignmentTypeOptions);
        }
      } else if (allConsignmentTypeOptions.length > 0) {
        setConsignmentTypeOptions(allConsignmentTypeOptions);
      }
    })();
  }, [customerId, allConsignmentTypeOptions]);

  const [response, setResponse] = useState({});

  console.log("documentSet", currentDocuments);

  useEffect(() => {
    (async () => {
      if (editMode) {
        if (response) {
          setIsLocConItemLoading(true);
          setIsOtherInfoLoading(true);
          setIsTransportLoading(true);
          setDocReference(response.reqId);

          const documents = [];
          documents.push(...response.documentResponses);

          const data = {
            opeRefMap: {
              8: jobs,
              10: insIds,
            },
          };
          const jobDocuments = await getDocumentByMultipleOpeAndRef(data);
          console.log("jobDocuments", jobDocuments);

          Object.keys(jobDocuments).forEach((key) => {
            documents.push(...jobDocuments[key]);
          });

          setCurrentDocuments(documents);

          // Ensure doc reference is set before loading document upload component.
          setIsFetchLoading(false);

          const requestCreationInit = {
            reqCode: response.reqCode,
            reqId: response.reqId,
            reqLCustomerId: response.reqLCustomerId,
            reqBehalfOf:
              response.reqBehalfOf !== null &&
              response.reqBehalfOf !== undefined &&
              response.reqBehalfOf !== ""
                ? parseInt(response.reqBehalfOf)
                : null,
            reqLPlantId: response.reqLPlantId,
            reqDepartment: response.reqDepartment,
            reqBookingRequiredDate: response.reqBookingRequiredDate,
            reqBookingRequiredDateFormatted: response.reqBookingRequiredDate
              ? formatFromJsonDate(response.reqBookingRequiredDate)
              : "",
            tempBookingRequiredDate: response.reqBookingRequiredDate,
            reqContactPerson: response.reqContactPerson,
            reqContactNumber: response.reqContactNumber,
            reqContactEmail: response.reqContactEmail,
            reqShipmentType: response.reqShipmentType,
            reqExportImport: response.reqExportImport,
            reqDeliveryCutoff: response.reqDeliveryCutoff,
            reqReferanceValue: response.reqReferanceValue,
            reqInvoiceRef: response.reqInvoiceRef,
            reqVessel: response.reqVessel,
            reqVayage: response.reqVayage,
            reqConsolidateAllowed: response.reqConsolidateAllowed,

            reqPackages: response.reqPackages,
            reqPono: response.reqPono,
            reqBlno: response.reqBlno,
            reqOperationType: response.reqOperationType,
            reqDeliveryCutoffFormatted: response.reqDeliveryCutoff
              ? formatFromJsonDate(response.reqDeliveryCutoff)
              : "",
          };

          dispatch(
            requestActions.setRequest({
              reqLCustomerId: requestCreationInit.reqLCustomerId,
            }),
          );

          dispatch(
            requestActions.setRequest({
              reqBookingRequiredDate:
                requestCreationInit.reqBookingRequiredDate,
              tempBookingRequiredDate:
                requestCreationInit.reqBookingRequiredDate,
            }),
          );

          dispatch(requestActions.setCurrentValues({ requestCreationInit }));

          const requestSummary = {
            reqQty: response.reqQty,
            reqUom: response.reqUom,
            reqCbm: response.reqCbm,
            reqCbmUom: response.reqCbmUom,
            reqTotalKm: response.reqTotalKm,
            reqApprovedBy: response.reqApprovedBy,
            reqRemarks: response.reqRemarks,
            reqApprovedDate: response.reqApprovedDate,
            reqApprovedDateFormatted: response.reqApprovedDate
              ? formatFromJsonDate(response.reqApprovedDate)
              : "",
            reqStatus: response.reqStatus,
            requestSchedulerResponse: response.requestSchedulerResponse,
          };

          dispatch(requestActions.setCurrentValues({ requestSummary }));

          const requestTransporter = {
            reqItemTypes: response.reqItemTypes,
            reqManageItems: response.reqManageItems,
            reqMultiConsignee: response.reqMultiConsignee,
            reqConsignmentType: response.reqConsignmentType,
            reqContainerno: response.reqContainerno,
            reqVehicleTypeId: response.reqVehicleTypeId,
            reqContainerType: response.reqContainerType,
            reqNumberOfVehicles: response.reqNumberOfVehicles,
            reqNumberOfTrailers: response.reqNumberOfTrailers,
            reqGrossWeight: response.reqGrossWeight,
            reqTotalValye: response.reqTotalValye,
            reqConsignee: response.reqConsignee,
            reqConsigneeCbm: response.reqConsigneeCbm,
            reqConsigneeQty: response.reqConsigneeQty,
          };

          if (response.reqVehicleTypeId) {
            dispatch(
              requestActions.setRequest({
                vehicleMaxCbm: response?.vehicleMaxCbm,
              }),
            );
          }

          setIsTransportLoading(false);

          dispatch(
            requestActions.setRequest({
              reqMultiConsignee: requestTransporter.reqMultiConsignee,
            }),
          );

          let singleConsigneeData = {};

          if (requestTransporter.reqMultiConsignee === 1) {
            dispatch(
              requestActions.setCurrentValues({
                requestTransporterData: {
                  requestTransporter,
                  singleConsigneeData,
                },
              }),
            );
          } else {
            const firstActiveLocation = response.requestLocationsResponses.find(
              (location) => location.rlkActive === 1,
            );
            const consigneeId =
              firstActiveLocation.requestConsigneesResponses &&
              firstActiveLocation.requestConsigneesResponses.length > 0
                ? firstActiveLocation.requestConsigneesResponses[0].rcoConsignee
                : null;

            singleConsigneeData = {
              rcoCbm: response.reqCbm,
              rcoQty: response.reqQty,
              rcoConsignee: consigneeId,
            };
            dispatch(
              requestActions.setCurrentValues({
                requestTransporterData: {
                  requestTransporter,
                  singleConsigneeData,
                },
              }),
            );
            dispatch(
              requestActions.setRequest({
                singleConsignee: consigneeId,
              }),
            );
          }

          let requestLocations = {
            requestStartLocation: {},
            requestEndLocation: {},
            requestViaLocations: [],
          };
          let requestConsignees = [];
          let id = 2;

          for (let location of response.requestLocationsResponses) {
            for (let consignee of location.requestConsigneesResponses) {
              requestConsignees.push({
                ...consignee,
                rcoId: consignee.rcoId,
                rcoCode: consignee.rcoCode,
                rcoLocation: location.rlkLocation,
                rcoConsignee: consignee.rcoConsignee,
                rcoConsignmentType: consignee.rcoConsignmentType,
                rcoCbm: consignee.rcoCbm,
                rcoQty: consignee.rcoQty,
                rcoActive: consignee.rcoActive,
                id,
              });

              id++;
            }

            if (location.rlkLocationType === 1) {
              requestLocations = {
                ...requestLocations,
                requestStartLocation: {
                  ...location,
                  id: parseInt(location.rlkSeq) + 1,
                  rlkId: location.rlkId,
                  rlkCode: location.rlkCode,
                  rlkLocation: location.rlkLocation,
                  rlkLocationType: location.rlkLocationType,
                  rlkArrivalEta: location.rlkArrivalEta,
                  rlkArrivalEtaFormatted: formatFromJsonDate(
                    location.rlkArrivalEta,
                  ),
                  rlkDepartureEta: location.rlkDepartureEta,
                  rlkDepartureEtaFormatted: formatFromJsonDate(
                    location.rlkDepartureEta,
                  ),
                  rlkContactPersonId: location.rlkContactPersonId,
                  rlkAddress: location.rlkAddress,
                  rlkEmail: location.rlkEmail,
                  rlkContactNumber: location.rlkContactNumber,
                  rlkLon:
                    location.rlkLon !== null && location.rlkLon !== ""
                      ? parseFloat(location.rlkLon)
                      : null,
                  rlkLat:
                    location.rlkLat !== null && location.rlkLat !== ""
                      ? parseFloat(location.rlkLat)
                      : null,
                  rlkSeq: location.rlkSeq,
                  rlkActive: location.rlkActive,
                  requestConsigneesRequests: [],
                },
              };
            } else if (location.rlkLocationType === 2) {
              requestLocations = {
                ...requestLocations,
                requestEndLocation: {
                  ...location,
                  id: parseInt(location.rlkSeq) + 1,
                  rlkId: location.rlkId,
                  rlkCode: location.rlkCode,
                  rlkLocation: location.rlkLocation,
                  rlkLocationType: location.rlkLocationType,
                  rlkArrivalEta: location.rlkArrivalEta,
                  rlkArrivalEtaFormatted: formatFromJsonDate(
                    location.rlkArrivalEta,
                  ),
                  rlkDepartureEta: location.rlkDepartureEta,
                  rlkDepartureEtaFormatted: formatFromJsonDate(
                    location.rlkDepartureEta,
                  ),
                  rlkContactPersonId: location.rlkContactPersonId,
                  rlkAddress: location.rlkAddress,
                  rlkEmail: location.rlkEmail,
                  rlkContactNumber: location.rlkContactNumber,
                  rlkLon:
                    location.rlkLon !== null && location.rlkLon !== ""
                      ? parseFloat(location.rlkLon)
                      : null,
                  rlkLat:
                    location.rlkLat !== null && location.rlkLat !== ""
                      ? parseFloat(location.rlkLat)
                      : null,
                  rlkSeq: location.rlkSeq,
                  rlkActive: location.rlkActive,
                  requestConsigneesRequests: [],
                },
              };
            } else {
              requestLocations = {
                ...requestLocations,
                requestViaLocations: [
                  ...requestLocations.requestViaLocations,
                  {
                    ...location,
                    id: parseInt(location.rlkSeq) + 1,
                    rlkId: location.rlkId,
                    rlkCode: location.rlkCode,
                    rlkLocation: location.rlkLocation,
                    rlkLocationType: location.rlkLocationType,
                    rlkArrivalEta: location.rlkArrivalEta,
                    rlkArrivalEtaFormatted: formatFromJsonDate(
                      location.rlkArrivalEta,
                    ),
                    rlkDepartureEta: location.rlkDepartureEta,
                    rlkDepartureEtaFormatted: formatFromJsonDate(
                      location.rlkDepartureEta,
                    ),
                    rlkContactPersonId: location.rlkContactPersonId,
                    rlkAddress: location.rlkAddress,
                    rlkEmail: location.rlkEmail,
                    rlkContactNumber: location.rlkContactNumber,
                    rlkLon:
                      location.rlkLon !== null && location.rlkLon !== ""
                        ? parseFloat(location.rlkLon)
                        : null,
                    rlkLat:
                      location.rlkLat !== null && location.rlkLat !== ""
                        ? parseFloat(location.rlkLat)
                        : null,
                    rlkSeq: location.rlkSeq,
                    rlkActive: location.rlkActive,
                    requestConsigneesRequests: [],
                  },
                ],
              };
            }
          }

          dispatch(requestActions.setCurrentValues({ requestLocations }));
          dispatch(
            requestActions.setRequest({
              requestLocationsRequests: [
                requestLocations.requestStartLocation,
                requestLocations.requestEndLocation,
                ...requestLocations.requestViaLocations,
              ],
            }),
          );

          dispatch(requestActions.setConsignees(requestConsignees));
          dispatch(
            requestActions.setRequest({
              editModeConsigneeCount: requestConsignees.length + 2,
            }),
          );
          setIsLocConItemLoading(false);
          const requestOtherResponses = [];
          let otherId = 2;
          for (let value of response.requestOtherResponses) {
            requestOtherResponses.push({
              ...value,
              id: otherId++,
            });
          }
          dispatch(requestActions.setRequest({ editModeOtherCount: otherId }));
          dispatch(requestActions.setOther(requestOtherResponses));
          setIsOtherInfoLoading(false);
        }
      }
    })();

    return () => {
      dispatch(requestActions.resetRequest());
      dispatch(requestActions.setRequest({ viewOnlyMode }));
    };
  }, [editMode, response, dispatch, cleanUp]);

  const validateAndSortLocations = (requestLocations, bookingReqDate) => {
    const errors = [];
    const requestStartLocation = requestLocations.find(
      (location) => location.rlkLocationType === 1,
    );
    const requestEndLocation = requestLocations.find(
      (location) => location.rlkLocationType === 2,
    );
    if (bookingReqDate > requestStartLocation.rlkArrivalEta) {
      dispatch(requestActions.setRequest({ hasLocErrors: true }));
      dispatch(
        requestActions.setRequest({
          startLocationErrors: {
            rlkArrivalEta:
              "Start location arrival eta cannot be before booking required date",
          },
        }),
      );
      return;
    }
    const startLocationErrors =
      validateQuickRequestLocation(requestStartLocation);
    const endLocationErrors = validateQuickRequestLocation(requestEndLocation);

    const allLocations = [...requestLocations];

    const startLocationValidationFailed =
      Object.keys(startLocationErrors).length > 0;
    const endLocationValidationFailed =
      Object.keys(endLocationErrors).length > 0;

    if (startLocationValidationFailed) {
      dispatch(requestActions.setRequest({ hasLocErrors: true }));
      dispatch(requestActions.setRequest({ startLocationErrors }));
    }
    if (endLocationValidationFailed) {
      dispatch(requestActions.setRequest({ hasLocErrors: true }));
      dispatch(requestActions.setRequest({ endLocationErrors }));
    }

    if (startLocationValidationFailed || endLocationValidationFailed) {
      return null;
    }

    const viaLocations = allLocations.filter(
      (location) => location.rlkLocationType === 3 && location.rlkActive === 1,
    );
    const deletedViaLocations = allLocations.filter(
      (location) => location.rlkLocationType === 3 && location.rlkActive === 2,
    );
    const sortedLocations = [...viaLocations, requestStartLocation].sort(
      (a, b) => a.rlkSeq - b.rlkSeq,
    );
    sortedLocations.push(requestEndLocation);
    let prevLocation = null;
    let seq = 1;
    const validatedSortedList = [];
    for (let location of sortedLocations) {
      if (isBeforeJson(location.rlkDepartureEta, location.rlkArrivalEta)) {
        errors.push({
          error: "Departure date should be after arrival date",
          seq: location.rlkSeq,
        });
      }
      if (prevLocation) {
        if (
          isBeforeJson(location.rlkArrivalEta, prevLocation.rlkDepartureEta)
        ) {
          errors.push({
            error: "Arrival date should be after previous location departure",
            seq: location.rlkSeq,
          });
        } else {
          location = { ...location, rlkSeq: seq };
          seq++;
          validatedSortedList.push(location);
        }
      } else {
        location = { ...location, rlkSeq: seq };
        seq++;
        validatedSortedList.push(location);
      }
      prevLocation = location;
    }
    if (errors.length > 0) {
      dispatch(requestActions.setRequest({ validationErrors: errors }));
      dispatch(requestActions.setRequest({ hasLocErrors: true }));
      return null;
    } else {
      dispatch(requestActions.setRequest({ hasLocErrors: false }));
      return [...validatedSortedList, ...deletedViaLocations];
    }
  };

  const handleLocationUpdate = (updatedLocations) => {
    dispatch(requestActions.updateLocations(updatedLocations));
    modalRef.current.close();
  };
  const submitHandler = async () => {
    setIsSubmitLoading(true);

    const requestState = store.getState();
    const requestData = requestState.request;
    let data = {};

    setHasRequestInitErrors(false);
    setHasRequestTransportErrors(false);
    setHasRequestSummaryErrors(false);
    dispatch(requestActions.setRequest({ submitted: true }));
    dispatch(requestActions.resetErrors());
    let hasErrors = false;

    const requestInitData = requestInitRef.current?.getData();
    const reqInitErrors = validateQuickRequestInitiation(requestInitData);
    setHasRequestInitErrors(Object.keys(reqInitErrors).length > 0);
    if (Object.keys(reqInitErrors).length > 0) {
      hasErrors = true;
      dispatch(requestActions.setRequest({ requestInitErrors: reqInitErrors }));
    }

    const requestTransportData = requestTransportRef.current?.getData();
    let reqTransportErrors =
      validateQuickRequestTransport(requestTransportData);
    if (requestData.reqMultiConsignee === 2) {
      const singleConsigneeData =
        requestTransportRef.current.getSingleConsignee();
      if (
        singleConsigneeData.rcoCbm === null ||
        singleConsigneeData.rcoCbm === ""
      ) {
        reqTransportErrors = {
          ...reqTransportErrors,
          rcoCbm: "CBM is required",
        };
      } else {
        if (singleConsigneeData.rcoCbm === 0) {
          reqTransportErrors = {
            ...reqTransportErrors,
            rcoCbm: "CBM is required",
          };
        }
      }
    }
    setHasRequestTransportErrors(Object.keys(reqTransportErrors).length > 0);
    if (Object.keys(reqTransportErrors).length > 0) {
      hasErrors = true;
      dispatch(
        requestActions.setRequest({
          requestTransporterErrors: reqTransportErrors,
        }),
      );
    }

    const requestSummaryFormData = requestSummaryRef.current?.getData();
    const requestSummaryData = {
      ...requestSummaryFormData,
      reqCbm: requestData.reqCbm,
      reqQty: requestData.reqQty,
    };
    const requestSchedulerData =
      requestSummaryRef.current?.getRequestSchedulerData();

    if (requestData.reqCbm !== 0 && requestData.vehicleMaxCbm) {
      if (requestData.reqCbm > requestData.vehicleMaxCbm) {
        dispatch(
          requestActions.setRequest({
            hasConErrors: true,
            hasSummaryErrors: true,
            requestSummaryErrors: {
              reqCbm: "CBM should be less than vehicle max CBM",
            },
          }),
        );
        hasErrors = true;
        setHasRequestSummaryErrors(true);
      }
    } else {
      dispatch(
        requestActions.setRequest({
          hasConErrors: true,
          hasSummaryErrors: true,
          requestSummaryErrors: {
            reqCbm:
              requestData.reqCbm === null ||
              requestData.reqCbm === "" ||
              requestData.reqCbm === 0
                ? "No request CBM"
                : "No vehicle max CBM",
          },
        }),
      );
      hasErrors = true;
      setHasRequestSummaryErrors(true);
    }

    const scheduleType =
      requestSummaryRef.current.getRequestSchedulerData().rscScheduleType;
    let schedulerErrors = [];
    if (scheduleType !== undefined && scheduleType !== null) {
      if (scheduleType === 1) {
        schedulerErrors = schedulerOneDayValidation(
          requestSummaryRef.current.getRequestSchedulerData(),
        );
      } else if (scheduleType === 4) {
        schedulerErrors = schedulerMonthlyValidation(
          requestSummaryRef.current.getRequestSchedulerData(),
        );
      } else {
        schedulerErrors = schedulerValidation(
          requestSummaryRef.current.getRequestSchedulerData(),
        );
      }

      if (Object.keys(schedulerErrors).length > 0) {
        dispatch(
          errorActions.validateRequestScheduler({
            schedulerData: schedulerErrors,
          }),
        );
        setIsSubmitLoading(false);
        return;
      }
    }

    const locations = requestData.requestLocationsRequests;

    const sortedLocation = validateAndSortLocations(
      locations,
      requestData.tempBookingRequiredDate,
    );

    if (!sortedLocation) {
      hasErrors = true;
    }
    if (hasErrors) {
      toast.error("Error creating request", {
        autoClose: 5000,
        containerId: "Main",
      });
      setIsSubmitLoading(false);
      return;
    }
    let mappedSortedLocation = [];

    if (requestData.reqMultiConsignee === 1) {
      const reqConsignees = requestData.requestConsigneesRequests;
      const activeConsignees = reqConsignees.filter(
        (item) => item.rcoId || item.rcoActive === 1,
      );
      if (activeConsignees.length < 2) {
        dispatch(
          requestActions.setRequest({
            hasConErrors: true,
            consigneeValidationErrors: [
              {
                error: "At least 2 consignees are required",
              },
            ],
          }),
        );
        toast.error("Error creating request", {
          containerId: "Main",
          autoClose: 3000,
        });
        setIsSubmitLoading(false);
        return;
      }
      mappedSortedLocation = sortedLocation.map((location) => {
        activeConsignees.forEach((consignee) => {
          if (consignee.rcoLocation === location.rlkLocation) {
            location = {
              ...location,
              //rlkId: null,
              requestConsigneesRequests: [
                ...location.requestConsigneesRequests,
                {
                  rcoLocation: consignee.rcoLocation,
                  rcoConsignee: consignee.rcoConsignee,
                  rcoConsignmentType: consignee.rcoConsignmentType,
                  rcoCbm: consignee.rcoCbm,
                  rcoQty: consignee.rcoQty,
                  rcoActive: consignee.rcoActive,
                  requestItemsRequests: [],
                },
              ],
            };
          }
        });
        return location;
      });
    } else {
      const singleConsigneeData =
        requestTransportRef.current.getSingleConsignee();
      let consignee = null;

      consignee = {
        rcoConsignee: requestData.singleConsignee,
        rcoCbm: requestData.reqQty,
        rcoQty: requestData.reqCbm,
      };

      mappedSortedLocation = sortedLocation.map((location) => {
        location = {
          ...location,
          // rlkId: null,
          requestConsigneesRequests: consignee.rcoConsignee
            ? [
                {
                  rcoCbm: 0,
                  rcoQty: 0,
                  rcoConsignee: singleConsigneeData.rcoConsignee,
                  rcoLocation: location.rlkLocation,
                  rcoActive: 1,
                  requestItemsRequests: [],
                },
              ]
            : [
                {
                  rcoCbm: 0,
                  rcoQty: 0,
                  rcoConsignee: null,
                  rcoLocation: location.rlkLocation,
                  rcoActive: 2,
                  requestItemsRequests: [],
                },
              ],
        };
        return location;
      });
    }

    const startLocation = mappedSortedLocation.find(
      (location) => location.rlkLocationType === 1,
    );
    const endLocation = mappedSortedLocation.find(
      (location) => location.rlkLocationType === 2,
    );

    const reqStarkRlkId = startLocation.rlkLocation;
    const reqEndRlkId = endLocation.rlkLocation;
    const reqOthers = requestData.requestOtherRequests;

    const activeOthers = reqOthers.filter(
      (item) => item.rotId || item.rotActive === 1,
    );

    const documents = docRef.current.getData();

    data = {
      ...requestInitData,
      reqBookingRequiredDate: requestData.reqBookingRequiredDate,
      ...requestTransportData,
      ...requestSummaryData,
      reqStarkRlkId,
      reqEndRlkId,
      requestLocationsRequests: mappedSortedLocation,
      requestSchedulerRequests: requestSchedulerData,
      requestOtherRequests: activeOthers.map((other) => {
        return { ...other, rotId: null };
      }),
      author: user.username,
    };

    try {
      let response = null;
      if (editMode) {
        const res = await updateRequestInitiation({
          ...data,
          context: context,
          jobId: jobId,
        });
        if (res.status < 0) {
          toast.error(res.message, {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsSubmitLoading(false);
          return;
        }

        console.log("quick request update", data);

        let hasUploadErrors = false;
        for (let doc of documents.created) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append("documentRequest", JSON.stringify(rest));
          formData.append("isImage", rest.docCategory === 1);
          const res = await addAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Main",
            });
          } else {
            hasUploadErrors = true;
            docRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error adding document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
          }
        }
        for (let doc of documents.modified) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append("documentRequest", JSON.stringify(rest));
          formData.append("isImage", rest.docCategory === 1);
          const res = await updateAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Main",
            });
          } else {
            hasUploadErrors = true;
            docRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error updating document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
          }
        }
        if (documents?.deleted.length > 0) {
          await deleteDocumentList({
            docIdList: documents?.deleted,
          });
          toast.success("Documents deleted successfully!", {
            autoClose: 5000,
            containerId: "Main",
          });
        }
        toast.success(`Request successfully updated `, {
          autoClose: 5000,
          containerId: "Main",
        });

        if (hasUploadErrors) {
          setIsSubmitLoading(false);
          return;
        }

        setEditMode(false);
        if (cleanUp) {
          cleanUpFunction();
        } else {
          window.location.reload();
        }
      } else {
        const returnedResponse = await addRequestInitiation({
          ...data,
          reqComId: userCompany ? userCompany.comId : null,
        });
        response = returnedResponse?.response;
        let hasUploadErrors = false;
        for (let doc of documents) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append(
            "documentRequest",
            JSON.stringify({
              ...rest,
              docReference: response.reqId,
            }),
          );
          formData.append("isImage", rest.docCategory === 1);
          const res = await addAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Main",
            });
          } else {
            hasUploadErrors = true;
            docRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error adding document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
          }
        }
        const documentResponses = await getDocumentByOpeAndRef(
          7,
          response.reqId,
        );
        response = { ...response, documentResponses };

        toast.success(`Request ${response.reqCode} successfully created `, {
          autoClose: 5000,
          containerId: "Main",
        });
        if (hasUploadErrors) {
          setIsSubmitLoading(false);
          return;
        }
        dispatch(requestActions.resetRequest());
      }
      setResponse(response);
      setEditMode(true);
      setStep(1);
      setIsSubmitLoading(false);
    } catch (e) {
      console.error(e);
      if (e?.response?.data?.message) {
        toast.error(e?.response?.data?.message, {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        toast.error("Error creating request", {
          autoClose: 5000,
          containerId: "Main",
        });
      }
      setIsSubmitLoading(false);
    }
  };

  //console.log("quick request update",  data);

  const handleAccordionClick = (index) => {
    setActiveAccordion((prev) => {
      if (prev.includes(index)) {
        return prev.filter((i) => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  return (
    <>
      <div>
        <h1 style={{ marginBottom: "20px" }}>Quick Request Creation</h1>
        <div style={{ marginTop: "10px" }}>
          <div
            className="ui styled accordion"
            style={
              requestInitiationViewPermission
                ? { width: "100%", marginBottom: "10px" }
                : { width: "100%", marginBottom: "10px", display: "none" }
            }
          >
            <div
              className={`title ${activeAccordion.includes(1) ? "active" : ""} `}
              onClick={() => handleAccordionClick(1)}
            >
              <i className="dropdown icon"></i>
              <i
                className="file icon"
                style={{ color: "green", marginRight: "10px" }}
              ></i>
              Request Initiation
            </div>
            <div
              className={`content ${activeAccordion.includes(1) ? "active" : ""}`}
            >
              <QuickRequestInitiation
                ref={requestInitRef}
                showMandatory={true}
                editMode={editMode}
                dropdown={{
                  departmentTypeOptions,
                  shipmentTypeOptions,
                  shipmentCategoryOptions,
                  yesNoOptions,
                }}
              />
            </div>
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <div
            className="ui styled accordion"
            style={
              requestTransportViewPermission
                ? { width: "100%", marginBottom: "10px" }
                : { width: "100%", marginBottom: "10px", display: "none" }
            }
          >
            <div
              className={`title ${activeAccordion.includes(2) ? "active" : ""} `}
              onClick={() => handleAccordionClick(2)}
            >
              <i className="dropdown icon"></i>
              <i
                className="truck icon"
                style={{ color: "green", marginRight: "10px" }}
              ></i>
              Transport Information
            </div>
            <div
              className={`content ${activeAccordion.includes(2) ? "active" : ""}`}
            >
              <QuickRequestTransport
                ref={requestTransportRef}
                isLoading={isTransportLoading}
                editMode={editMode}
                dropdown={{
                  itemTypeOptions,
                  consignmentTypeOptions,
                  yesNoOptions,
                }}
              />
            </div>
          </div>
        </div>
        <div
          style={
            requestConsigneeViewPermission || requestLocationViewPermission
              ? { marginTop: "20px" }
              : { display: "none" }
          }
        >
          <div
            className="ui styled accordion"
            style={{ width: "100%", marginBottom: "10px" }}
          >
            <div
              className={`title ${activeAccordion.includes(3) ? "active" : ""} `}
              onClick={() => handleAccordionClick(3)}
            >
              <i className="dropdown icon"></i>
              <i
                className="map icon"
                style={{ color: "green", marginRight: "10px" }}
              ></i>
              Location/Consignees
            </div>
            <div
              className={`content ${activeAccordion.includes(3) ? "active" : ""}`}
            >
              <QuickLocationConsigneeItem
                onShowLocation={() => {
                  modalRef.current?.showModal();
                }}
                editMode={editMode}
                dropdown={{ locationFlagOptions, consignmentTypeOptions }}
                isLoading={isLocConItemLoading}
              />
            </div>
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <div
            className="ui styled accordion"
            style={
              requestOtherInfoViewPermission
                ? { width: "100%", marginBottom: "10px" }
                : { width: "100%", marginBottom: "10px", display: "none" }
            }
          >
            <div
              className={`title ${activeAccordion.includes(4) ? "active" : ""} `}
              onClick={() => handleAccordionClick(4)}
            >
              <i className="dropdown icon"></i>
              <i className="list icon" style={{ marginRight: "10px" }}></i>
              Other Information
            </div>
            <div
              className={`content ${activeAccordion.includes(4) ? "active" : ""}`}
            >
              <QuickRequestOtherInfo
                ref={requestOtherRef}
                dropdown={{ chargeTypeOptions, statusTypeOptions }}
                editMode={editMode}
                isLoading={isOtherInfoLoading}
              />
            </div>
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <div
            className="ui styled accordion"
            style={
              requestSummaryViewPermission
                ? { width: "100%", marginBottom: "10px" }
                : { width: "100%", marginBottom: "10px", display: "none" }
            }
          >
            <div
              className={`title ${activeAccordion.includes(5) ? "active" : ""} `}
              onClick={() => handleAccordionClick(5)}
            >
              <i className="dropdown icon"></i>
              <i className="info icon" style={{ marginRight: "10px" }}></i>
              Summary Information
            </div>
            <div
              className={`content ${activeAccordion.includes(5) ? "active" : ""}`}
            >
              <QuickRequestSummary
                ref={requestSummaryRef}
                editMode={editMode}
                dropdown={{
                  uomTypeOptions,
                  statusTypeOptions,
                  scheduleTypeOptions,
                  activeOptions,
                  timeUomOptions,
                }}
              />
            </div>
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <div
            className="ui styled accordion"
            style={{ width: "100%", marginBottom: "10px" }}
          >
            <div
              className={`title ${activeAccordion.includes(6) ? "active" : ""} `}
              onClick={() => handleAccordionClick(6)}
            >
              <i className="dropdown icon"></i>
              <i className="upload icon" style={{ marginRight: "10px" }}></i>
              Document Upload
            </div>
            <div
              className={`content ${activeAccordion.includes(6) ? "active" : ""}`}
            >
              <DocumentUpload
                viewOnlyMode={viewOnlyMode}
                reference={docReference}
                module={MODULES.Transaction}
                opeType={7}
                ref={docRef}
                dropdown={{
                  documentTypeOptions,
                  statusOptions: statusTypeOptions,
                  fileNameOptions,
                  activeOptions,
                }}
                isLoading={isFetchLoading}
                editMode={editMode}
                currentValues={currentDocuments}
              />
            </div>
          </div>
        </div>

        <div
          className="extra content"
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            marginBottom: "20px",
          }}
        >
          {editMode && context === 1 && (
            <Button
              label="Reset Form"
              Icon={GrFormRefresh}
              onClick={() => {
                window.location.reload();
              }}
            />
          )}
          {editMode ? (
            <Button
              template="submit"
              disabled={viewOnlyMode}
              onClick={submitHandler}
              isLoading={isSubmitLoading}
              create={!editMode}
              form={FORMS.QUICK_REQUEST.CREATION.form}
              module={MODULES.Transaction}
              authenticated={true}
              editMode={editMode}
            />
          ) : (
            <Button
              template="submit"
              disabled={viewOnlyMode}
              onClick={submitHandler}
              isLoading={isSubmitLoading}
              create={!editMode}
              form={FORMS.QUICK_REQUEST.CREATION.form}
              module={MODULES.Transaction}
              authenticated={true}
              editMode={editMode}
            />
          )}
        </div>
      </div>

      <Modal
        ref={modalRef2}
        minWidth="70vw"
        clickOutSide={false}
        closeButton={false}
      >
        <JobConfirmationAlert
          alerts={jobConfirmAlerts}
          closeModal2={closeModal2}
        />
      </Modal>
    </>
  );
};
export default QuickRequestRefactor;
